import MainLayout from "components/layout/main-layout/MainLayout";
import { titles } from "constants/titles";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getContactUsApi } from "redux/auth/actions";
import './SubscriptionRenew.css'

const RenewSubscription = () => {
    const contactData = useSelector((store) => store?.auth?.contactUsDetails);
    const userData = useSelector((store) => store?.auth?.userData);
    const dispatch = useDispatch();

    useEffect(() => {
        getContactUsApi(
            dispatch,
            !userData?.isGuestUser ? "accountowner" : "guestuser"
        );
    }, [])

    return (
        <MainLayout
            text={titles?.renewSubscription}
            isBackHide={false}
            isSemiHeader={true}
            isNavbar={false}
            white={true}
        >
            <p className="signature_need_desc">
                {`${titles?.renewSubscriptionMessage}${contactData?.customer_care_no}`}
            </p>
        </MainLayout>
    );
}

export default RenewSubscription